import store from '@sb/store'
var Drag = require('./dragscroll.js')

var sb = require('@sb/util')

export default {
	name: 'QuickReplies',
	props: ['convoKey'],

	data () {
		return {
			...store.bind(this, ['agentM', 'user', 'convoEventM']),
			events: [],
		}
	},

	mounted () {
		store.onConvoEvent(this, ev => {
			var evconvokey = sb.convoKeyOfEv(ev)
			if (evconvokey !== this.convoKey) return
			this.$forceUpdate()
		})

		Drag(this.$refs.quickreplies, () => {})
	},

	render () {
		// must alway return $refs.quickreplies or Drag will fail
		var events = sb.orderBy(
			sb.map(this.convoEventM[this.convoKey], e => e),
			'created',
			'desc',
		)
		// find first msg_sent event of agent
		var last_agent_sent
		for (let ev of events) {
			if (sb.get(ev, 'type') !== 'message_sent') continue
			last_agent_sent = ev
			break
		}

		if (sb.get(last_agent_sent, 'by.type') === 'user') last_agent_sent = null

		var quickreplies = []
		sb.map(sb.get(last_agent_sent, 'data.message.attachments', []), att => {
			if (!att) return
			if (att.type === 'quick_replies') {
				quickreplies = sb.map(att.quick_replies, r => r.title || '')
			}
		})

		quickreplies = sb.filter(quickreplies, r => !!r)
		let cls = quickreplies.length > 0 ? '' : 'quick-replies-container--hidden'
		let $replies = sb.map(quickreplies, r => (
			<div class="quick-replies--item" vOn:click={() => this.selectReply(last_agent_sent, r)}>
				{r}
			</div>
		))

		return (
			<div class={`quick-replies-container ${cls}`}>
				<div ref="quickreplies" class="quick-replies">
					{$replies}
				</div>
			</div>
		)
	},

	methods: {
		selectReply (ev, r) {
			this.$emit('select', r)
		},
	},
}
